import { render } from "./OtlPlotsBlock.vue?vue&type=template&id=58f344c1&scoped=true&ts=true"
import script from "./OtlPlotsBlock.vue?vue&type=script&lang=ts"
export * from "./OtlPlotsBlock.vue?vue&type=script&lang=ts"

import "./OtlPlotsBlock.vue?vue&type=style&index=0&id=58f344c1&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f344c1"]])

export default __exports__